// Components
import Seed from './Seed/Seed';

// Config
import { APP_TGE_LINK } from '../../config';

// Styles
import styles from './Seeds.module.scss';

export const SEEDS_KEYS = {
  tmx: 'TMX Private SEED',
  tge: 'TGE',
  live: 'Live',
};

const Seeds = () => {
  return (
    <ul className={styles.wrapper}>
      <Seed seedText={SEEDS_KEYS.tmx} isCompleted />
      <Seed seedText={SEEDS_KEYS.tge} linkTo={APP_TGE_LINK} />
      <Seed seedText={SEEDS_KEYS.live} isSoon />
    </ul>
  );
};

export default Seeds;
